import { useTranslation } from "react-i18next";
import { Button } from "barte-design-system";
import { BarcodeIcon } from "@phosphor-icons/react";

import { CardInfo } from "@shared/components";
import { formatDelay, formatPercentage, formatCurrency } from "@shared/helpers";
import type { CardBoletoProps } from "./card-boleto.type";
import styles from "../../rate-plan-details.module.css";

export const CardBoleto = ({
    isLoading,
    data,
    companyPlan,
    onEdit,
}: CardBoletoProps) => {
    const { t } = useTranslation();

    const getTotalRate = () => {
        if (data?.rateType === "PERCENTAGE") {
            return formatPercentage(data?.value);
        }

        return `${formatCurrency(data?.value)}`;
    };

    const totalRateValue = getTotalRate();

    const getMarkupValue = () => {
        const object = {
            "PERCENTAGE_PERCENTAGE": formatPercentage(data?.value - companyPlan?.value),
            "FIXED_FIXED": formatCurrency(data?.value - companyPlan?.value),
            "PERCENTAGE_FIXED": `${formatPercentage(data?.value)} - ${formatCurrency(companyPlan?.value)}`,
            "FIXED_PERCENTAGE": `${formatCurrency(data?.value)} - ${formatPercentage(companyPlan?.value)}`,
        }

        return object[`${data?.rateType}_${companyPlan?.rateType}`] || "-";
    };

    const markupValue = getMarkupValue();

    const items = [
        {
            key: "redeemTime",
            label: t("payfac.pageRatePlanDetailsRedeemTime"),
            value: formatDelay(data?.delayForRedeem),
        },
        {
            key: "rateType",
            label: t("payfac.pageRatePlanDetailsRateType"),
            value:
                data?.rateType === "PERCENTAGE"
                    ? t("payfac.pageRatePlanDetailsPercentage")
                    : t("payfac.pageRatePlanDetailsFixed"),
        },
        {
            key: "markup",
            label: t("payfac.pageRatePlanDetailsMarkup"),
            value: markupValue,
        },
        {
            key: "totalRate",
            label: t("payfac.pageRatePlanDetailsTotalRate"),
            value: totalRateValue,
        },
        {
            key: "rateLimit",
            label: t("payfac.pageRatePlanDetailsRateLimit"),
            value: formatCurrency(data?.valueLimit),
        },
    ];


    return (
        <CardInfo
            title={
                <span className={styles["card-title"]}>
                    <BarcodeIcon className={styles.icon} />{" "}
                    {t("payfac.pageRatePlanDetailsBoleto")}
                </span>
            }
            action={
                <Button size="sm" variant="outline" onClick={onEdit}>
                    {t("payfac.pageRatePlanDetailsEditButton")}
                </Button>
            }
            isLoading={isLoading}
            info={items}
        />
    );
};
